module.exports = "/_next/static/images/btn-first-charge-2d3c5e0c.png";